var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system footer-margin"},[_c('Breadcrumb'),_c('div',{staticClass:"container footer-margin",domProps:{"innerHTML":_vm._s(_vm.body)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }